import axios from "axios";

const BASE_URL = "https://api.coudy.ai/user"; // Replace with your API base URL

export async function fetchNotifications(token) {
    const response = await axios.get(`${BASE_URL}/notifications`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
}

export async function markNotificationAsRead(token, notificationId) {
    await axios.post(
        `${BASE_URL}/notifications/${notificationId}/read`,
        {},
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
}
